module.exports = __webpack_public_path__ + "img/tree.526c776.webp";